import get from "lodash/get";
import { createSelector } from "reselect";

export const baseSystemMessagesSelector = (state) => get(state, 'systemMessages', {});

export const currenciesSelector = createSelector(baseSystemMessagesSelector, (systemMessages) =>
  get(systemMessages, 'release_notes', {})
);